import { useEffect } from "react";
import products from "./Pdata";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./product.css";

const ProductListHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Easing animation
      once: true, // Whether animation should happen only once
    });
  }, []);

  return (
    <div className="pdlist border-bottom mt-5">
      <p className="text-uppercase text-center text-success mb-5 p-1">
        Sản phẩm của Mễ Mễ
      </p>
      <div className="container">
        <div data-aos="zoom-out" className="row justify-content-center">
          {products.map((prod, i) => (
            <div
              key={i}
              className="col-6 col-sm-6 col-md-4 d-flex flex-column align-items-center mb-1"
              onClick={() =>
                navigate("/products", { state: { category: prod.title } })
              }
            >
              <div>
                <img
                  className="p-1 product-img rounded-circle bg-success"
                  src={prod.path}
                  alt={prod.title}
                />
              </div>
              <p
                className="text-center text-muted"
                style={{ fontSize: "14px" }}
              >
                {prod.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductListHome;
